import { Navigate } from "react-router-dom";
import useStudentAuth from "../../hooks/useStudentAuth";

export default function StudentRoute({ children }) {
  const isLoggedIn = useStudentAuth();
  return isLoggedIn ? children : <Navigate to="/" />;
}
